export default __webpack_public_path__ + "static/media/conteudo_extra_14_26.82d1f743.jpg";